import { msg } from '@lingui/macro';

export const mustHaveEmployee = msg`You must have an employee record in Intacct to create a timesheet.`;
export const noEditPermissions = msg`You do not have permissions to edit timesheets in Intacct.`;
